import React from 'react';
import PropTypes from 'prop-types';
import CreditAssessmentStatus from '../../../model/CreditAssessmentStatus';
import './CreditAssessmentErrorMessage.scss';

const getErrorMessage = (caError) => {
  if (caError && caError.text && caError.text === CreditAssessmentStatus.IN_PROGRESS) {
    return 'Your Credit Assessment is still in progress. Please wait about 15 seconds and then click NEXT again '
      + 'to see if your Credit Assessment has completed.';
  }
  if (caError && caError.text && caError.text === CreditAssessmentStatus.INCORRECT_ID) {
    return 'We found some errors in your information. We suggest you double check everything to make sure it’s 100% '
      + 'correct. If you see a mistake then tidy this up and re-submit your application.';
  }
  return 'Oops, something went wrong. Please try again later.';
};

const CreditAssessmentErrorMessage = (props) => {
  const { caError } = props;
  if (caError) {
    return (
      <div className="ca-error-container">
        {getErrorMessage(caError)}
      </div>
    );
  }
  return null;
};

CreditAssessmentErrorMessage.propTypes = {
  caError: PropTypes.object
};

export default CreditAssessmentErrorMessage;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentErrorMessage/CreditAssessmentErrorMessage.js
 **/